import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { useAppTranslation } from '@hooks';
import { PresetTag } from '@components/display';
import { TSkillType } from '@definitions';
import {
  Avatar,
  Col,
  colors,
  HoverCard,
  IAvailableIcons,
  Icon,
  IconButton,
  Row,
  Space,
  Text,
} from 'common-components';

const ContentContainer = styled(Col, {
  shouldForwardProp: (prop) => prop !== 'archived',
})<{ archived: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  background-color: ${({ archived }) => (archived ? colors.gray300 : colors.white)};
`;
const FooterContainer = styled(Row)`
  width: 100%;
  height: 56px;
`;
const HoverContentContainer = styled(Row)`
  width: 100%;
`;

export type CardFormActionType = {
  icon: IAvailableIcons
  onClick: () => void
};

type CardFormPropsType = {
  form: {
    idForm: string
    name: string
    skill: TSkillType
    updateDate: string
    nbReviewers: number
  }
  actions: CardFormActionType[]
  header?: ReactNode
  decoration?: ReactNode
  archived?: boolean
  children?: ReactNode
};
const CardForm = ({
  form,
  actions,
  header,
  decoration,
  archived = false,
  children,
}: CardFormPropsType) => {
  const { translate } = useAppTranslation();

  return (
    <HoverCard
      style={{ width: '100%' }}
      ContentComponent={
        <ContentContainer archived={archived}>
          {decoration}
          {header}
          <Text
            size="md"
            color={colors.gray900}
            style={{ fontWeight: 500, paddingRight: decoration ? 32 : 0 }}
          >
            {form.name}
          </Text>
          {form.skill !== null && form.skill !== undefined && (
            <PresetTag
              preset="skill"
              state={form.skill}
              style={{ fontSize: 14, lineHeight: '20px', padding: '2px 10px' }}
            >
              {translate(`common.states.skill.${form.skill}`)}
            </PresetTag>
          )}
          {children}
          <Text size="xs" color={colors.gray400}>
            {translate('form.updatedOn', { date: form.updateDate })}
          </Text>
        </ContentContainer>
      }
      footerContent={
        <FooterContainer align={'middle'} justify={'space-between'}>
          {/*FIXME: no avatar data*/}
          <Avatar size="xs" />
          {form.nbReviewers !== null && form.nbReviewers !== undefined && (
            <Space size={4}>
              <Icon icon={'UsersEdit'} color={colors.gray400} size={20} />
              <Text size="xs" color={colors.gray600}>
                {translate('form.entries', { count: form.nbReviewers })}
              </Text>
            </Space>
          )}
        </FooterContainer>
      }
      hoverFooterContent={
        !!actions.length && (
          <HoverContentContainer align={'middle'} justify={'center'}>
            {actions.map((action) => (
              <IconButton
                key={action.icon}
                icon={action.icon}
                type={'text'}
                iconProps={{ color: colors.white }}
                onClick={action.onClick}
              />
            ))}
          </HoverContentContainer>
        )
      }
    />
  );
};

export default CardForm;
